var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"safe-html",class:{ 'is-plain': _vm.isPlainText },domProps:{"innerHTML":_vm._s(_vm.sanitized)}})}
var staticRenderFns = []

export { render, staticRenderFns }